import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=17d3f3d1&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=ts"
export * from "./CoursesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3f3d1",
  null
  
)

export default component.exports